package net.maraclinic.app.styles

import org.jetbrains.compose.web.css.*

object ComponentsStyleSheet : StyleSheet() {


}